import React, { useEffect, useState } from "react";
import Ships from "./child/ShipDetails";

function AddShip() {
  const [activeTab, set_activeTab] = useState("ship");

  useEffect(() => {
    set_activeTab("ship");
    localStorage.setItem("selectedTab", "ship");
  }, []);

  const handleClick = (name) => {
    if (name === "ship") {
      set_activeTab(name);
      localStorage.setItem("selectedTab", name);
    }
  };

  return (
    <>
      <div className="white-container">
        <ul className="marine-tabs">
          <li className={activeTab === "ship" ? "active" : ""} onClick={() => handleClick("ship")}>
            Ship Basic Details
          </li>
          <li className="disabled">Main Engine</li>
          <li className="disabled">Auxiliary Engine</li>
          <li className="disabled">Auxiliary Machinary</li>
          <li className="disabled">Cargo Machinary</li>
          {/* <li className="disabled">Crane</li>
          <li className="disabled">Boiler</li>
          <li className="disabled">Pump</li>
          <li className="disabled">Purifier</li>
          <li className="disabled">Compressor</li> */}
          <li className="disabled">Alarm</li>
          <li className="disabled">Ship Tanks</li>
        </ul>
        {activeTab === "ship" && <Ships />}
        {/* Only Ship tab content is rendered */}
      </div>
    </>
  );
}

export default AddShip;
